import * as React from 'react'
import { Icon } from '../Icon'
import { IconListProps } from './types'
import { Wrapper } from './styled'
import { Tooltip } from '../Tooltip'

export const IconList = ({
  axis = 'horizontal',
  justify = 'flex-start',
  className,
  icons,
  iconSize,
  tooltipNowrap = false,
}: IconListProps) => {
  return (
    <div style={{ width: 'max-content', display: "flex" }}>
      <Wrapper className={className} axis={axis} justify={justify}>
        {icons.map((icon, index) => (
          <Tooltip text={icon.name} noWrap={tooltipNowrap}>
            <Icon name={icon.icon} key={index} iconSize={iconSize} />
          </Tooltip>
        ))}
      </Wrapper>
    </div>
  )
}
